import { parseImageStreamManifest } from './parseImageStreamManifest.js'
import { parseImageStreamUriFromManifest } from './parseImageStreamUriFromManifest.js'

export const getImageStream = async (manifestUri) => {
  const baseUrl = manifestUri.substring(0, manifestUri.split('?')[0].lastIndexOf('/'))

  const manifest = await fetchManifest(manifestUri)
  if (!manifest) return null

  const thumbsManifestUrl = parseImageStreamUriFromManifest(manifest, baseUrl)
  if (!thumbsManifestUrl) return null

  const thumbsManifest = await fetchManifest(thumbsManifestUrl)
  if (!thumbsManifest) return null

  return parseImageStreamManifest(thumbsManifest, baseUrl)
}

async function fetchManifest(manifestUri) {
  const response = await fetch(manifestUri, { mode: 'cors' })
  return response.ok ? response.text() : null
}
